export function getPaymentMethods(dataArray) {
  if(!dataArray) return []
  if(!dataArray.length > 0) return []
  let methods = dataArray?.map((data) => {
    return data?.descript;
  });
  methods = [...new Set(methods)];
  return methods;
}
